import { useDispatch, useSelector } from 'react-redux'
import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { RootState } from '@store/redux.store'
import { TaskTrackerState } from './taskTracker.types'

export type TaskTrackerAppState = RootState & {
  taskTracker: TaskTrackerState
}

export type TaskTrackerAppDispatch = ThunkDispatch<
  TaskTrackerAppState,
  unknown,
  AnyAction
>

export const useTaskTrackerDispatch = () =>
  useDispatch<TaskTrackerAppDispatch>()

export const useTaskTrackerSelector = <T,>(
  selector: (state: TaskTrackerAppState) => T,
): T =>
  useSelector((state: RootState) =>
    selector(state as TaskTrackerAppState),
  )
